import StrictObj from '../utils/strict-obj'

export default [
  StrictObj({
    name: 'unknown',
    icon: 'ggs-fa ggs-fa-times',
    color: 'ggs-clr__unknown',
    background: 'ggs-bg-clr__unknown'
  }),
  StrictObj({
    name: 'upload',
    icon: 'ggs-fa ggs-fa-user-o',
    color: 'ggs-clr__user',
    circle: 'ggs-icon__user-circle',
    stroke: 'ggs-icon__user-stroke',
    background: 'ggs-bg-clr__user'
  }),
  StrictObj({
    name: 'link',
    icon: 'ggs-fa ggs-fa-link',
    color: 'ggs-clr__link',
    background: 'ggs-bg-clr__link'
  }),
  StrictObj({
    name: 'email',
    icon: 'ggs-fa ggs-fa-envelope-o',
    color: 'ggs-clr__email',
    background: 'ggs-bg-clr__email'
  }),
  StrictObj({
    name: 'code',
    icon: 'ggs-fa ggs-fa-code',
    color: 'ggs-clr__code',
    background: 'ggs-bg-clr__code'
  }),
  StrictObj({
    name: 'globe',
    icon: 'ggs-fa ggs-fa-globe',
    color: 'ggs-clr__globe',
    background: 'ggs-bg-clr__globe'
  }),
  StrictObj({
    name: 'youtube',
    icon: 'ggs-fa ggs-fa-youtube-play',
    color: 'ggs-clr__youtube',
    background: 'ggs-bg-clr__youtube'
  }),
  StrictObj({
    name: 'instagram',
    icon: 'ggs-fa ggs-fa-instagram',
    color: 'ggs-clr__instagram',
    background: 'ggs-bg-clr__instagram'
  }),
  StrictObj({
    name: 'facebook',
    icon: 'ggs-fa ggs-fa-facebook',
    color: 'ggs-clr__facebook',
    background: 'ggs-bg-clr__facebook'
  }),
  StrictObj({
    name: 'vimeo',
    icon: 'ggs-fa ggs-fa-vimeo',
    color: 'ggs-clr__vimeo',
    background: 'ggs-bg-clr__vimeo'
  }),
  StrictObj({
    name: 'vine',
    icon: 'ggs-fa ggs-fa-vine',
    color: 'ggs-clr__vine',
    background: 'ggs-bg-clr__vine'
  }),
  StrictObj({
    name: 'soundcloud',
    icon: 'ggs-fa ggs-fa-soundcloud',
    color: 'ggs-clr__soundcloud',
    background: 'ggs-bg-clr__soundcloud'
  }),
  StrictObj({
    name: 'twitter',
    icon: 'ggs-fa ggs-fa-twitter',
    color: 'ggs-clr__twitter',
    background: 'ggs-bg-clr__twitter'
  }),
  StrictObj({
    name: 'pinterest',
    icon: 'ggs-fa ggs-fa-pinterest-p',
    color: 'ggs-clr__pinterest',
    circle: 'ggs-icon__pinterest-circle',
    stroke: 'ggs-icon__pinterest-stroke',
    background: 'ggs-bg-clr__pinterest'
  }),
  StrictObj({
    name: 'tumblr',
    icon: 'ggs-fa ggs-fa-tumblr',
    color: 'ggs-clr__tumblr',
    background: 'ggs-bg-clr__tumblr'
  })
]
